export default class Requisicao {
  constructor(
    id_requisicao = null,
    tipo = 'T',
    data_emissao = new Date(),
    finalizacao,
    id_requisitante = 1,
    id_estoque_saida,
    id_estoque_entrada,
    id_responsavel = 1,
    status = 'P',
    observacoes,
    id_empresa_producao,
    id_producao,
    itens = [],
    qtde_prevista = 0,
    qtde_realizada = 0
  ) {
    this.id_requisicao = id_requisicao;
    this.tipo = tipo;
    this.data_emissao = data_emissao;
    this.finalizacao = finalizacao;
    this.id_requisitante = id_requisitante;
    this.id_estoque_saida = id_estoque_saida;
    this.id_estoque_entrada = id_estoque_entrada;
    this.id_responsavel = id_responsavel;
    this.status = status;
    this.observacoes = observacoes;
    this.id_empresa_producao = id_empresa_producao;
    this.id_producao = id_producao;
    this.itens = itens;
    this.qtde_prevista = qtde_prevista;
    this.qtde_realizada = qtde_realizada;
  }
}